import { Injectable } from '@angular/core';

const STORAGE_KEY = 'sg-correlation-id';

/** Patrón UUID v4 estricto — previene log injection si el servidor devuelve un valor manipulado */
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

@Injectable({
  providedIn: 'root'
})
export class CorrelationIdService {

  private correlationId: string;

  constructor() {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    this.correlationId = (stored && UUID_REGEX.test(stored)) ? stored : this.generate();
    sessionStorage.setItem(STORAGE_KEY, this.correlationId);
  }

  getCorrelationId(): string {
    return this.correlationId;
  }

  /**
   * Sincroniza con el ID devuelto por el servidor, solo si es un UUID válido.
   * La validación previene que una respuesta manipulada inyecte caracteres de control.
   */
  syncFromServer(serverCorrelationId: string | null): void {
    if (serverCorrelationId
        && UUID_REGEX.test(serverCorrelationId)
        && serverCorrelationId !== this.correlationId) {
      this.correlationId = serverCorrelationId;
      sessionStorage.setItem(STORAGE_KEY, this.correlationId);
    }
  }

  /** Resetea el ID al hacer logout */
  reset(): void {
    this.correlationId = this.generate();
    sessionStorage.setItem(STORAGE_KEY, this.correlationId);
  }

  private generate(): string {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    // Fallback manual UUID v4
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}
